import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class DestinationsService {

  constructor(private http: HttpClient) { }
  updateDestination(id, body) {
    return this.http.put<ApiResponseModel>('api/city/' + id, body);
  }
  getDestination(id){
    return this.http.get<ApiResponseModel>('api/city/' + id);
  }
  getAllDestinations(){
    return this.http.get<ApiResponseModel>('api/city/destinations/');
  }
}
